import { render, staticRenderFns } from "./addServiceStation.vue?vue&type=template&id=66863f96&"
import script from "./addServiceStation.vue?vue&type=script&lang=js&"
export * from "./addServiceStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports